import { useEffect, useState } from 'react';

/** Heure courante, rafraîchie toutes les `intervalMs` (« Démarre dans 3 min »). */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
